import { useQuery } from '@tanstack/react-query'
import { fetchWithAuth } from '@/data/api/client'

export interface ModelGroup {
  provider: string
  models: string[]
}

async function getModels(): Promise<ModelGroup[]> {
  return fetchWithAuth('/api/v1/pricing-configurations/models')
}

export function useModels() {
  return useQuery({
    queryKey: ['pricing', 'models'],
    queryFn: getModels,
    staleTime: 60 * 1000, // Cache for 60 seconds
  })
}

